import { notificationsApi } from '@/modules/notifications/api/notifications-api'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { assistantEffects } from '@/lib/assistant-effects.generated'
import { useAuth } from '@/lib/auth'

import { notificationKeys } from '../../api/query-keys'

const assistantEffectMeta = {
  assistantEffects: [assistantEffects.notificationsChanged],
} as const

export function useMyNotifications() {
  const { isAuthenticated } = useAuth()
  return useQuery({
    queryKey: notificationKeys.mine(),
    queryFn: () => notificationsApi.getMyNotifications(),
    enabled: isAuthenticated,
    meta: assistantEffectMeta,
  })
}

export function useUnreadNotificationCount() {
  const { isAuthenticated } = useAuth()
  return useQuery({
    queryKey: notificationKeys.unreadCount(),
    queryFn: () => notificationsApi.getUnreadNotificationCount(),
    enabled: isAuthenticated,
    meta: assistantEffectMeta,
  })
}

export function useMarkAllNotificationsRead() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: () => notificationsApi.markAllNotificationsRead(),
    onSuccess: () =>
      void queryClient.invalidateQueries({ queryKey: notificationKeys.root }),
  })
}
